import { render, staticRenderFns } from "./ExtinguisherReportView.vue?vue&type=template&id=5fe04680&"
import script from "./ExtinguisherReportView.vue?vue&type=script&lang=js&"
export * from "./ExtinguisherReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports